import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Button} from './Button';

interface RemindButtonProps {
  shape: 'flat' | 'square';
  onClick: () => void;
  icon: ReactNode;
  texts: {
    short: string;
    long: string;
  };
}

export const FlattenableButton: FC<RemindButtonProps> = ({
  shape,
  onClick,
  icon,
  texts,
}) => {
  return (
    <RemindButtonHolder
      shape={shape}
      disableShadow
      type="secondary"
      data-testid="remindWhenProductAvailable"
      grow={false}
      onClick={onClick}
      aria-label={undefined}
    >
      {shape === 'flat' && icon}
      <RemindButtonTitle>
        {shape === 'flat' ? texts.long : texts.short}
      </RemindButtonTitle>
    </RemindButtonHolder>
  );
};

const RemindButtonHolder = styled(Button)<{shape: 'flat' | 'square'}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  align-content: center;
  ${({shape}) =>
    shape === 'flat'
      ? css`
          padding: 0;
        `
      : css`
          padding: 0.5625rem 0.75rem;
          border: 1px solid ${COLORS.Grey3};
        `};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
`;

const RemindButtonTitle = styled.span`
  margin-left: 0.25rem;
`;
